export enum ModelType {
  ACCRUED_INTEREST = 'AccruedInterest',
  ADDRESS = 'Address',
  AI_RESEARCH_ITEM = 'AiResearchItem',
  AI_SUMMARY = 'AiSummary',
  ANNOUNCEMENT = 'Announcement',
  ASSET = 'Asset',
  ATTACHMENT = 'Attachment',
  AUDIT = 'Audit',
  BILLING = 'Billing',
  CODICIL = 'Codicil',
  COMPANY = 'Company',
  COMPANY_SERVICE = 'CompanyService',
  CONTACT = 'Contact',
  CONTACT_MARRIAGE_HISTORY = 'ContactMarriageHistory',
  CONTENT_SOURCE = 'ContentSource',
  CONTENT_SOURCE_JURISDICTION = 'ContentSourceJurisdiction',
  CONTENT_SOURCE_ROLE = 'ContentSourceRole',
  CONVERSATION = 'Conversation',
  COURIER_PICKUP = 'CourierPickup',
  COURTHOUSE = 'Courthouse',
  CREDITOR_CLAIM = 'CreditorClaim',
  DEFAULT_PARTNER_PRODUCT = 'DefaultPartnerProduct',
  DEMO_TEMPLATE = 'DemoTemplate',
  DOCUMENT = 'Document',
  DOCUMENT_EXTRACTION = 'DocumentExtraction',
  EDITOR_TEMPLATE_DOCUMENT = 'EditorTemplateDocument',
  ESIGN_DOCUMENT = 'EsignDocument',
  ESIGN_ENVELOPE = 'EsignEnvelope',
  ESTATE_NOMINATION = 'EstateNomination',
  ESTATE_NOTIFY_CREDITOR_ENTRY = 'EstateNotifyCreditorEntry',
  ESTATE_DISTRIBUTION = 'EstateDistribution',
  ESTATE_DISTRIBUTION_PAYMENT = 'EstateDistributionPayment',
  ESTATE = 'Estate',
  ESTATE_ACCOUNT = 'EstateAccount',
  ESTATE_ACCOUNTING_QUEBEC_DISTRIBUTION = 'EstateAccountingQuebecDistribution',
  ESTATE_BANKING_ACCOUNT = 'EstateBankingAccount',
  ESTATE_BANKING_REQUEST = 'EstateBankingRequest',
  ESTATE_BANKING_REQUEST_NBC_META = 'EstateBankingRequestNbcMeta',
  ESTATE_BEREAVEMENT_REGISTRY_REQUEST = 'EstateBereavementRegistryRequest',
  ESTATE_FORM = 'EstateForm',
  ESTATE_FORM_TEMPLATE = 'EstateFormTemplate',
  ESTATE_INFORMATION_RETURN_APPLICATION = 'EstateInformationReturnApplication',
  ESTATE_INSTITUTION = 'EstateInstitution',
  ESTATE_INTERIM_DISTRIBUTION = 'EstateInterimDistribution',
  ESTATE_PLANNING_TYPE = 'EstatePlanningType',
  ESTATE_TASK = 'EstateTask',
  ESTATE_TAX_FORM = 'EstateTaxForm',
  ESTATE_TAX_FILING = 'EstateTaxFiling',
  ESTATE_UPSELL = 'EstateUpsell',
  ESTATE_UPSELL_CLEAR_ESTATE_META = 'EstateUpsellClearEstateMeta',
  ESTATE_UPSELL_CLEAR_WILL_META = 'EstateUpsellClearWillMeta',
  ESIGN_ENVELOPE_ESTATE_ACCOUNT = 'EsignEnvelopeEstateAccount',
  EXTRACTED_ASSET = 'ExtractedAsset',
  EXTRACTED_CONTACT = 'ExtractedContact',
  EXTRACTED_LIABILITY = 'ExtractedLiability',
  EXTRACTED_OPPORTUNITY = 'ExtractedOpportunity',
  EXTRACTED_USER = 'ExtractedUser',
  EXTRACTED_TRANSACTION = 'ExtractedTransaction',
  FEATURE_FLAG = 'FeatureFlag',
  FEATURE_FLAG_ESTATE = 'FeatureFlagEstate',
  FEATURE_FLAG_ESTATE_TYPE = 'FeatureFlagEstateType',
  FEATURE_FLAG_JURISDICTION = 'FeatureFlagJurisdiction',
  FEATURE_FLAG_USER = 'FeatureFlagUser',
  FEATURE_FLAG_COMPANY = 'FeatureFlagCompany',
  FEATURE_FLAG_BILLING_PLAN_MAPPING = 'FeatureFlagBillingPlanMapping',
  FINANCIAL_ACCOUNT = 'FinancialAccount',
  FINANCIAL_ACCOUNT_TRANSACTION = 'FinancialAccountTransaction',
  FINANCIAL_INSTITUTION = 'FinancialInstitution',
  FINAL_TAXES_ART_VALUABLE_ASSET = 'FinalTaxesArtValuableAsset',
  FINAL_TAXES_BANK_ACCOUNT_ASSET = 'FinalTaxesBankAccountAsset',
  FINAL_TAXES_BUSINESS_INTEREST_ASSET = 'FinalTaxesBusinessInterestAsset',
  FINAL_TAXES_OTHER_INVESTMENT_ASSET = 'FinalTaxesOtherInvestmentAsset',
  FINAL_TAXES_REAL_ESTATE_ASSET = 'FinalTaxesRealEstateAsset',
  GUIDANCE_STEP = 'GuidanceStep',
  HUBSPOT_DEAL = 'HubSpotDeal',
  HUBSPOT_LINE_ITEM = 'HubSpotLineItem',
  LIABILITY = 'Liability',
  LIFE_INSURANCE_PROVIDER = 'LifeInsuranceProvider',
  MAIL_NOTIFICATION = 'MailNotification',
  MEETING = 'Meeting',
  MESSAGE = 'Message',
  MESSAGE_DETAIL = 'MessageDetail',
  MESSAGE_MENTION = 'MessageMention',
  METRIC = 'Metric',
  NOTE = 'Note',
  NOTIFICATION = 'Notification',
  NOTIFICATION_BROADCAST = 'NotificationBroadcast',
  OPPORTUNITY = 'Opportunity',
  OPPORTUNITY_SCAN = 'OpportunityScan',
  PENSION_PLAN_PROVIDER = 'PensionPlanProvider',
  PLATFORM_REFERRAL = 'PlatformReferral',
  PET = 'Pet',
  PARTNERSHIP_INVITATION = 'PartnershipInvitation',
  POWER_OF_ATTORNEY_HEALTHCARE_DIRECTIVE = 'PowerOfAttorneyHealthcareDirective',
  POWER_OF_ATTORNEY_PERSONAL_CARE = 'PowerOfAttorneyPersonalCare',
  POWER_OF_ATTORNEY_PROPERTY = 'PowerOfAttorneyProperty',
  POWER_OF_EXECUTOR = 'PowerOfExecutor',
  PROBATE_APPLICATION = 'ProbateApplication',
  ESTATE_PROBATE_STATUS = 'EstateProbateStatus',
  PROBATE_COMMISSION_MEETING = 'ProbateCommissionMeeting',
  PROBATE_COMMISSION_PARTNER = 'ProbateCommissionPartner',
  PROBATE_DETERMINATION_ASSET = 'ProbateDeterminationAsset',
  PROFESSION = 'Profession',
  PROFESSIONAL = 'Professional',
  PROTECTION_MANDATE = 'ProtectionMandate',
  REFERRAL = 'Referral',
  REFERRAL_SETTLEMENT_META = 'ReferralSettlementMeta',
  REFERRAL_VAULT_META = 'ReferralVaultMeta',
  REMINDER = 'Reminder',
  DISTRIBUTION_ALTERNATE = 'DistributionAlternate',
  SOCIAL_ACCOUNT = 'SocialAccount',
  STOCK = 'Stock',
  STOCK_HOLDING = 'StockHolding',
  STATUS_ENTRY = 'StatusEntry',
  TIME_ENTRY = 'TimeEntry',
  TEAM = 'Team',
  TEAM_USERS = 'TeamUsers',
  TYPEFORM_ANSWER_SCORE = 'TypeformAnswerScore',
  TYPEFORM_FIELD = 'TypeformField',
  TYPEFORM_FORM = 'TypeformForm',
  TYPEFORM_RESPONSE = 'TypeformResponse',
  TYPEFORM_RESPONSE_ANSWER = 'TypeformResponseAnswer',
  TYPEFORM_THRESHOLD = 'TypeformThreshold',
  USER = 'User',
  VAULT_DISTRIBUTION_SETTING = 'VaultDistributionSetting',
  WILL = 'Will',
  WORKFLOW = 'Workflow',
  WORKFLOW_ASSIGNEE = 'WorkflowAssignee',
  WORKFLOW_JURISDICTION_RULE = 'WorkflowJurisdictionRule',
  WORKFLOW_TEAM_RULE = 'WorkflowTeamRule',

  GENERIC = ''
}
